import axios from "axios";
import { __static } from "@/settings";

// 获取通用静态配置
export function getStaticConfig() {
    return axios.get(`${__static}/common/system/conf/global.json`).then((res) => res.data);
}
